@if (visibility) {
<div class="pia-loading-overlay" [ngClass]="{ 'child-mode': childMode }">
  <div class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
  </div>
</div>
}
